export const AppendPowerpointElement = (src: string) => {
	const v = document.createElement("iframe");
	v.src = `https://view.officeapps.live.com/op/embed.aspx?src=${src}`;
	v.width="1280px";
	v.height="720px";
	v.frameBorder="0";
	v.scrolling="no";
	document.getElementById("container")?.appendChild(v);
	return v;
}